import { ReactComponent as TldlIcon } from 'assets/icons/tldl.svg';

export default TldlIcon;
